export default {
  meta: 'Оплата',
  name_artwork: 'Оплата размещения работы в маркете',
  name: 'Название работы',
  artist: 'Художник',
  owner: 'Владелец',
  price: ' Стоимость в месяц',
  pay: 'Оплатить',
};
